import { Directive, forwardRef, input, Type } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

export enum Titles {
  CEO = 'CEO',
  VP = 'VP',
  COO = 'COO',
  DIRECTOR = 'DIRECTOR',
  PRESIDENT = 'PRESIDENT',
  SVP = 'SVP'
}

/**
 * tdWbTitleNeedsNameValidator
 * Raises error when there is a title (CEO, VP) but there is no name informed
 */
@Directive({
  selector: '[tdWbTitleNeedsNameValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<TitleNeedsNameValidatorDirective> => TitleNeedsNameValidatorDirective),
    multi: true
  }]
})
export class TitleNeedsNameValidatorDirective implements Validator {
  readonly titles = input.required<Record<Titles, boolean>>({ alias: 'tdWbTitleNeedsNameValidator' });

  validate(thisControl: AbstractControl): ValidationErrors | null {
    const titles = this.titles();
    const hasTitle = titles.CEO || titles.VP ||
      titles.COO || titles.DIRECTOR ||
      titles.PRESIDENT || titles.SVP;
    const hasName = thisControl.value !== undefined && thisControl.value !== null && thisControl.value !== '';

    const needsName = !hasName && hasTitle;
    const needsTitle = hasName && !hasTitle;

    return (needsName || needsTitle) ? { requiredSubscriberAgentNameAndTitle: true } : null;
  }
}

